export enum SpreadsheetTypeEnum {
  'Result' = 1,
  'Consolidate'= 4,
}
